<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <h4 class="fw-bold py-3 " style="font-size: 17px;margin-left:20px; margin-top: 0.5cm;"><span
                class="text-muted fw-light">Business Profile /</span> Company Profile</h4>

        <mat-card>
            <mat-card-header class="mt-3">
                <span class="material-icons" style="margin-right: 10px;">
                    account_circle
                </span>Company Profile
            </mat-card-header>

            <hr class="my-0 mt-3 mb-5" />

            <mat-card-content>
                <form [formGroup]="publicDetailsForm" (ngSubmit)="onSubmit()">

                    <div class="d-flex align-items-start align-items-sm-center gap-4" style="margin-left:1cm;">
                        <img [src]="createImgPath(imageServerPath) " (error)="onImgError($event)" alt="user-avatar"
                            class="d-block rounded" height="100" width="100" id="uploadedAvatar" #fileUploader
                            aria-required="true" />

                        <div class="row">
                            <div class="button-wrapper">
                                <label for="upload" class="btn btn-primary me-2 mb-4" tabindex="0">
                                    <span class="d-none d-sm-block">Upload Logo</span>
                                    <i class="bx bx-upload d-block d-sm-none"><mat-icon>upload</mat-icon></i>
                                    <input type="file" id="upload" class="account-file-input" hidden
                                        accept="image/png, image/jpeg" name="File" formControlName="logoFile"
                                        (change)="upload($event.target.files)"
                                        [ngClass]="{'is-invalid':submitted && forms.logoFile.errors}" required>
                                </label>


                                <button type="reset" class="btn btn-outline-secondary account-image-reset mb-4"
                                    (click)="resetImage()">
                                    <span class="d-none d-sm-block">Reset</span>
                                    <i class="bx bx-reset d-block d-sm-none"><mat-icon>restore</mat-icon></i>
                                </button>

                                <p class="text-muted mb-0">Allowed JPG or PNG. Max size of 800KB</p>
                                <div class="mb-2 mt-2"></div>
                                <div class="progress" *ngIf="progress > 0">
                                    <div class=" bg-success" role="progressbar" [style.width.%]="progress" style="color:
                                rgb(39, 237, 39)">
                                        <span class="upload" style="color: rgb(245, 241, 241);">
                                            {{progress}}%
                                        </span>
                                    </div>
                                </div>
                                <span class="upload" *ngIf="message">
                                    {{message}}
                                </span>
                            </div>
                            <mat-error *ngIf="submitted && forms.logoFile.errors" class="invalid-feedback">
                                <div *ngIf="forms.logoFile.errors.required"> This field is required </div>
                            </mat-error>

                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-md-6">
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="email">
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>

                                <mat-form-field appearance="outline">
                                    <mat-label>Official Website</mat-label>
                                    <input matInput formControlName="officialWebsite">
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="adminControls">
                                <mat-form-field appearance="outline">
                                    <mat-label>Phone Number</mat-label>
                                    <input matInput formControlName="phoneNumber" placeholder="XXX-XXX-XXXX">
                                    <mat-error>This field is required</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <alert></alert>
                    <mat-card-actions>
                        <button type="button" mat-raised-button style="margin-left:40px;" class="button"
                            (click)="onSubmit()">
                            <span class="material-symbols-outlined" *ngIf="status==false">
                                edit
                            </span>
                            <!-- <mat-icon class="icons" *ngIf="status==false">edit </mat-icon>  -->
                            <mat-icon class="icons" *ngIf="status==true">save</mat-icon>
                            {{status==false ? 'Edit' :'Save Changes' }}
                        </button>
                        <button mat-raised-button *ngIf="status" (click)="reset()" class="buttonReset">
                            Cancel</button>
                    </mat-card-actions>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div id="loadingspinner" *ngIf="isLoading">
    <div class="spinner">
        <img src="../../../assets/images/spinner.gif" alt="Loading. Please wait.">
    </div>
</div>